import { all } from 'redux-saga/effects';

import loginSagas from 'Core/views/login/redux/saga';
import authContainerSagas from 'Core/containers/Auth/redux/saga';
import generalContainerSagas from 'Core/containers/General/redux/saga';
import commonSagas from 'Core/common/redux/saga';
import preferencesSagas from 'Core/containers/Preferences/redux/saga';
import catalogSagas from 'Core/catalogs/redux/saga';
import confirmUserSagas from 'Core/views/confirmUser/redux/saga';
import forgotPasswordSagas from 'Core/views/forgotPassword/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        loginSagas(),
        authContainerSagas(),
        generalContainerSagas(),
        commonSagas(),
        preferencesSagas(),
        catalogSagas(),
        confirmUserSagas(),
        forgotPasswordSagas(),
    ])
}